import { gql } from '@apollo/client'

export const MUTATION_REPLACE_BROKEN_DEVICE = gql`
  mutation mutationReplaceBrokenDevice($input: ReplaceBrokenDeviceInput!) {
    createReplaceBrokenDevice(input: $input) {
      id
    }
  }
`
